import { render } from "./SectionArtworkCard.vue?vue&type=template&id=0deb4596&scoped=true"
import script from "./SectionArtworkCard.vue?vue&type=script&lang=js"
export * from "./SectionArtworkCard.vue?vue&type=script&lang=js"

import "./SectionArtworkCard.vue?vue&type=style&index=0&id=0deb4596&lang=css"
import "./SectionArtworkCard.vue?vue&type=style&index=1&id=0deb4596&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0deb4596"]])

export default __exports__